/* Shiprocket gift: required phone model and conditional engraving name. */
(() => {
  const init = () => {
    document.querySelectorAll('[data-sr-phone-wrap]').forEach(phoneWrap => {
      if (phoneWrap.dataset.srReady) return;
      const product = phoneWrap.closest('.js-product');
      const picker = product?.querySelector('desitech-variant-picker');
      const model = phoneWrap.querySelector('input');
      const wrap = product?.querySelector('[data-sr-name-wrap]');
      const name = wrap?.querySelector('input');
      const form = document.getElementById(model.getAttribute('form'));
      if (!picker || !form) return;
      phoneWrap.dataset.srReady = 'true';
      const sync = () => {
        const design = picker.getSelectedOptions()[0] || '';
        const needed = design.includes('+ Name');
        if (wrap && name) {
          wrap.hidden = !needed;
          name.disabled = !needed;
          name.required = needed;
          if (!needed) name.setCustomValidity('');
        }
      };
      const validate = event => {
        sync();
        for (const input of [model, name]) {
          if (!input || input.disabled) continue;
          input.setCustomValidity(input.required && !input.value.trim() ? input.dataset.requiredMessage : '');
          if (!input.checkValidity()) {
            input.reportValidity();
            input.focus();
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
        }
      };
      [model, name].filter(Boolean).forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
      sync();
      picker.addEventListener('change', () => setTimeout(sync, 80));
      form.addEventListener('submit', validate, true);
      form.querySelector('[name="add"]')?.addEventListener('click', validate, true);
    });
  };
  const start = () => customElements.whenDefined('desitech-variant-picker').then(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* Follow either selection as soon as a matching design/colour is available. */
(() => {
  const init = () => document.querySelectorAll('[data-sr-phone-wrap]').forEach(wrap => {
    const product = wrap.closest('.js-product');
    const picker = product?.querySelector('desitech-variant-picker');
    const gallery = product?.querySelector('desitech-media-gallery');
    if (!picker || !gallery || picker.dataset.srGalleryReady) return;
    picker.dataset.srGalleryReady = 'true';
    const sync = () => {
      const options = picker.getSelectedOptions();
      if (!options.some(Boolean)) return;
      const variant = picker.data.variants.find(v => v.options.every((value,index) => !options[index] || value === options[index]));
      if (variant?.featured_media?.id) gallery.setActiveMedia(variant.featured_media.id);
    };
    picker.addEventListener('change', () => setTimeout(sync, 20));
    sync();
  });
  const start = () => Promise.all([customElements.whenDefined('desitech-variant-picker'),customElements.whenDefined('desitech-media-gallery')]).then(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();